import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import toast from "react-hot-toast";
import SliderContent from "../components/SliderContent";
import { userurl1 } from "../helperFunctions/apiFunction";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  const handleResetPassword = async (e) => {
    e.preventDefault();

    // Check if passwords match
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      // Call the API function to reset the password
      const response = await fetch(
        `${userurl1}/client/auth/reset-password?token=${token}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            password: password,
          }),
        }
      );

      // Assuming the API returns a success message
      if (response.ok) {
        toast.success(
          "Password reset successfully. You can now log in with your new password."
        );
        navigate("/login");

        // Optionally, redirect to the login page
        // history.push("/login");
      } else {
        const responseBody = await response.json();
        toast.error(
          responseBody.msg || "Failed to reset password. Please try again."
        );
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };


  return (
    <div className="app-container app-theme-white body-tabs-shadow">
      <div className="app-container">
        <div className="h-100">
          <div className="h-100 no-gutters row">
            <div className="h-100 d-md-flex d-sm-block bg-white justify-content-center align-items-center col-md-12 col-lg-7">
              <div className="mx-auto app-login-box col-sm-12 col-md-10 col-lg-9">
                <h4>
                  <div>Set a New Password</div>
                  <span>Enter your new password below:</span>
                </h4>
                <form className="" onSubmit={handleResetPassword}>
                  <div className="form-row">
                    <div className="col-md-12">
                      <div className="position-relative form-group">
                        <label htmlFor="password" className="">
                          <span className="text-danger">*</span> New Password
                        </label>
                        <input
                          name="password"
                          type="password"
                          className="form-control"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="position-relative form-group">
                        <label htmlFor="confirmPassword" className="">
                          <span className="text-danger">*</span> Confirm
                          Password
                        </label>
                        <input
                          name="confirmPassword"
                          type="password"
                          className="form-control"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 d-flex align-items-center">
                    <div className="ml-auto">
                      <button
                        className="btn-wide btn-pill btn-shadow btn-hover-shine btn btn-primary btn-lg"
                        type="submit"
                      >
                        Set Password
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="d-lg-flex d-xs-none col-lg-5">
              <div className="slider-light">
                <div className="">
                  <SliderContent />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
